import { useQuery } from "@tanstack/react-query";
import { useTacticHooks } from "../../providers/TacticHooksProvider";

export interface UseGetTessaChatMessagesOptions {
  chatId: string;
  enabled?: boolean;
}

export function useGetTessaChatMessages(
  options: UseGetTessaChatMessagesOptions
) {
  const { apiClient } = useTacticHooks();
  const {
    data: messages,
    error,
    isFetching
  } = useQuery({
    queryKey: ["tessa.chat.messages", options.chatId],

    queryFn: async () => {
      const res = await apiClient.tessa.getChatMessages(options.chatId);
      return res.result;
    },

    enabled: options.enabled !== false
  });

  return { messages, error, isFetching };
}
